import React, { useState, useEffect } from 'react';
import { Table, Card, Button, message, Space, Input } from 'antd';
import { PlusOutlined, SearchOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';

const SubjectList = () => {
    const [subjects, setSubjects] = useState([]);
    const [loading, setLoading] = useState(false);
    const [searchText, setSearchText] = useState('');
    const navigate = useNavigate();

    // Fetch subjects data
    const fetchSubjects = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${config.apiUrl}/api/v1/subjects`);
            setSubjects(response?.data || []);
        } catch (error) {
            message.error('Không thể tải danh sách môn học!');
            console.error('Error fetching subjects:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchSubjects();
    }, []);


    // Table columns definition
    const columns = [
        {
            title: 'Mã môn học',
            dataIndex: 'code',
            key: 'code',
            sorter: (a, b) => a.code.localeCompare(b.code),
            filteredValue: [searchText],
            onFilter: (value, record) => {
                return (
                    String(record.code).toLowerCase().includes(value.toLowerCase()) ||
                    String(record.name).toLowerCase().includes(value.toLowerCase())
                );
            },
        },
        {
            title: 'Tên môn học',
            dataIndex: 'name',
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            filters: [
                { text: 'Hoạt động', value: true },
                { text: 'Không hoạt động', value: false },
            ],
            onFilter: (value, record) => record.status === value,
            render: (status) => (status ? 'Hoạt động' : 'Không hoạt động'),
        },
        {
            title: 'Thao tác',
            key: 'action',
            render: (_, record) => (
                <Space size="middle">
                    <Button 
                        type="link" 
                        onClick={() => navigate(`/subjects/edit/${record.id}`)}
                    >
                        Sửa
                    </Button>
                    <Button 
                        type="link" 
                        onClick={() => navigate(`/subjects/${record.id}`)}
                    >
                        Chi tiết
                    </Button>
                </Space>
            ),
        },
    ];

    return (
        <Card 
            title="Danh sách môn học" 
            extra={
                <Space>
                    <Input
                        placeholder="Tìm kiếm môn học..."
                        prefix={<SearchOutlined />}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ width: 200 }}
                    />
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => navigate('/subjects/create')}
                    >
                        Thêm môn học
                    </Button>
                </Space>
            }
        >
            <Table
                columns={columns}
                dataSource={subjects}
                rowKey="id"
                loading={loading}
                pagination={{
                    total: subjects.length,
                    pageSize: 10,
                    showTotal: (total) => `Tổng số ${total} môn học`,
                    showSizeChanger: true,
                    showQuickJumper: true,
                }}
            />
        </Card>
    );
};

export default SubjectList; 